export * from './error.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/pages/auth/error/index.ts